import { render, staticRenderFns } from "./IframeLink.vue?vue&type=template&id=41fc68c2&scoped=true"
import script from "./IframeLink.vue?vue&type=script&lang=js"
export * from "./IframeLink.vue?vue&type=script&lang=js"
import style0 from "./IframeLink.vue?vue&type=style&index=0&id=41fc68c2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fc68c2",
  null
  
)

export default component.exports